// 库存路由
export default {
  path: "/inventory",
  name: "inventory",
  meta: { title: "库存", icon: "inventory" },
  children: [
    {
      path: "/inventory/realInventory",
      name: "realInventory",
      component: () =>
        import(
          /* webpackChunkName: "realInventory" */ "@/views/warehouse/inventory/realInventory"
        ),
      meta: { title: "实时库存", icon: "inventory-real" },
    },
  ],
};
